import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import profile from "./profile.module";

import fire from "./fire.module";

import { vuexfireMutations } from "vuexfire";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  mutations: vuexfireMutations,
  actions: {},
  modules: {
    fire,
    auth,
    htmlClass,
    config,
    breadcrumbs,
    profile,
  },
});
